import { render, staticRenderFns } from "./Front.vue?vue&type=template&id=2b10ba34&scoped=true"
import script from "./Front.vue?vue&type=script&lang=js"
export * from "./Front.vue?vue&type=script&lang=js"
import style0 from "./Front.vue?vue&type=style&index=0&id=2b10ba34&prod&lang=scss&scoped=true"
import style1 from "./Front.vue?vue&type=style&index=1&id=2b10ba34&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b10ba34",
  null
  
)

export default component.exports